import { getGetApiChatBotDataListQueryKey, BotProvider, useGetApiChatBotDataList, BsonDocument, BotProviderType } from "@/API";
import { Button, Divider, Group, Loader, Modal, NumberInput, Select, Stack, Switch, Textarea, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { PropsWithChildren, useEffect, useState } from "react";
import { LineBotProviderDataEditForm } from "./Line/LineBotProviderDataEdit";
import { WebBotProviderDataEditForm } from "./Web/WebBotProviderDataEdit";


export function BotProviderCreateButton(props: { workspaceId: string, onChange?: (botProvider: BotProvider) => void } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);
    const chatBotDataList = useGetApiChatBotDataList({ workspaceId: props.workspaceId ?? "" }, {
        query: {
            queryKey: getGetApiChatBotDataListQueryKey({ workspaceId: props.workspaceId ?? "" }),
            enabled: !!props.workspaceId
        }
    })
    const [providerData, setProviderData] = useState<BsonDocument>({})

    const form = useForm<BotProvider>({
        initialValues: {
            workspaceId: props.workspaceId,
            type: "Line",
            providerData: {
            },
            textProcessConfig: {
            },
            botConfig: {
            },
            userChatHandlerConfigs: []
        },
    });
    useEffect(() => {
        if (opened) {
            form.reset()
        }
    }, [opened])

    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} size="xl" title="Bot">
            <Select
                label="機器人類別"
                data={[
                    { label: "Line", value: "Line" },
                    { label: "Web", value: "Web" }
                ]}
                {...form.getInputProps('type')}
            />
            <TextInput
                label="名稱"
                {...form.getInputProps('name')}
            />
            {
                form.values.type == "Line" && <LineBotProviderDataEditForm value={providerData} onChange={setProviderData} />
            }
            {
                form.values.type == "Web" && <WebBotProviderDataEditForm value={providerData} onChange={setProviderData} enableLivePreview={false} />
            }
            <form onSubmit={form.onSubmit((values) => {
                values.providerData = providerData
                props.onChange?.(values)
                close()
            })}>
                <Divider my="md" />
                {
                    chatBotDataList.isFetching ? <Loader /> :
                        (chatBotDataList.data?.data.results?.length ?? 0) > 0 ?
                            <Select
                                label="連接機器人"
                                placeholder="機器人名稱"
                                allowDeselect={true}
                                data={chatBotDataList.data?.data.results?.filter(x => !!x.id).map(x => {
                                    return {
                                        label: `${x.name ?? "unknown"}(${x.id})`,
                                        value: x.id!
                                    }
                                }) ?? []}
                                {...form.getInputProps('chatBotDataId')}
                            /> : <></>
                }
                <Stack gap={5} mt={5}>
                    <Switch
                        label="強制去除Markdown"
                        {...form.getInputProps('textProcessConfig.forceRemoveMarkdown', { type: "checkbox" })}
                    />
                    <Switch
                        label="強制簡轉繁"
                        {...form.getInputProps('textProcessConfig.foreceHansToTW', { type: "checkbox" })}
                    />
                </Stack>
                <Stack gap={5} mt={5}>
                    <Textarea
                        label="思考中回應"
                        rows={3}
                        {...form.getInputProps('botConfig.waitingResponseMessage')}
                    />
                    <NumberInput
                        label="多少秒還沒回答自動回應思考中回應(0表示關閉此功能)"
                        min={0}
                        step={1}
                        {...form.getInputProps('botConfig.waitingResponseTime')}
                    />
                    <Textarea
                        label="發生錯誤時的回應"
                        rows={3}
                        {...form.getInputProps('botConfig.errorMessage')}
                    />
                </Stack>
                <Group justify="flex-end" mt="md">
                    <Button type="submit">確認</Button>
                </Group>
            </form>
        </Modal>
    </>
}